import { createStore, compose, applyMiddleware, combineReducers } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import { createLogger } from 'redux-logger';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { reducer as formReducer } from 'redux-form';

import reducers from './reducers';
// import { actions } from '../auth/duck';

// The global persist config, on application root level
const persistConfig = {
  key: 'root',
  storage,
  whitelist: [],
};

// Auth persist config, which keeps only the `token` field.
// Don't persist any of the other fields (isLoading, error...),
// otherwise - when the user opens the app, old errors or wrong loading states
// might appear. Instead, reset everything else but the token.
const authPersistConfig = {
  key: 'auth',
  storage,
  blacklist: ['error', 'isFetching', 'invalidAfter'],
};

const combinedReducers = combineReducers({
  ...reducers,
  auth: persistReducer(authPersistConfig, reducers.auth),
  form: formReducer,
});

/**
 * Reset the state of a Redux store on logout
 * {@link https://stackoverflow.com/a/35641992/2765346}
 */
const appReducers = (state, action) => {
  let reducerState = state;

  /**
   * TODO: Reset the state of a Redux store on logout
   * {@link https://stackoverflow.com/a/35641992/2765346}
   */
  // if (action.type === actions.LOGOUT) {
  //  reducerState = undefined;
  // }

  return combinedReducers(reducerState, action);
};

const persistedReducers = persistReducer(persistConfig, appReducers);

const logger = createLogger({
  collapsed: true,
  duration: true,
});

let store;
if (process.env.NODE_ENV === 'development') {
  store = createStore(
    persistedReducers,
    composeWithDevTools(applyMiddleware(thunk, logger))
  );
} else {
  store = createStore(persistedReducers, compose(applyMiddleware(thunk)));
}

export default store;
export const persistor = persistStore(store);



// WEBPACK FOOTER //
// ./src/core/store.js